<template>
  <div class="pt-radio h-100">
    <div class="container-fluid pt-2 pt-md-5">
      <div class="row">
        <div class="col-12">
          <RadioNasional />
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <RadioNegeri />
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <!-- ads bottom -->
          <billboardBannerTop v-if="desktop"></billboardBannerTop>
          <mrecBannerTop v-if="mobile"></mrecBannerTop>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <RadioTempatan />
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <!-- ads bottom -->
          <BillboardBannerBottom v-if="desktop"></BillboardBannerBottom>
          <MrecBannerBottom v-if="mobile"></MrecBannerBottom>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import RadioPlayer from "@/components/players/radioPlayer.vue";
import billboardBannerTop from "../components/ads/radio/billboardBannerTop.vue";
import mrecBannerTop from "../components/ads/radio/mrecBannerTop.vue";
import billboardbannerbottom from "../components/ads/radio/billboardBannerBottom";
import mrecbannerbottom from "../components/ads/radio/mrecBannerBottom";
// v1
import RadioMainCarousel from "../components/carousel/radio/v1/radioFeaturedCarousel.vue";
import RadioNasional from "../components/carousel/radio/v2/radioNasional.vue";
import RadioNegeri from "../components/carousel/radio/v2/radioNegeri.vue";
import RadioTempatan from "../components/carousel/radio/v2/radioTempatan.vue";
import axios from "axios";
export default {
  components: {
    RadioMainCarousel,
    RadioPlayer,
    billboardBannerTop,
    mrecBannerTop,
    billboardbannerbottom,
    mrecbannerbottom,
    RadioNasional,
    RadioNegeri,
    RadioTempatan,
  },
  data: function() {
    return {
      id: this.$route.params.id,
      currentid: 0,
      radio: [],
      tablet: false,
      mobile: false,
      desktop: false,
    };
  },
  beforeMount() {
    // this.initializeContentForStart();
  },
  mounted() {
    this.deviceCheck();
    if (!this.$route.params.id) {
      setTimeout(
        function() {
          this.initializecontentview();
          this.initializepageview();
        }.bind(this),
        700
      );
    }
  },
  methods: {
    deviceCheck() {
      if (this.$device.ipad) {
        this.tablet = true;
      } else if (this.$device.mobile) {
        this.mobile = true;
      } else {
        this.desktop = true;
      }
    },
    filterOtherFolderData(obj) {
      this.radio.push(obj);
      this.currentid = obj[0].id;
    },
    getRadioData() {
      try {
        axios.get(``).then((response) => {
          var radio_order = [4, 7, 6, 3, 5];

          var data = response.data.data;

          data.sort(function(a, b) {
            return radio_order.indexOf(a.id) - radio_order.indexOf(b.id);
          });

          this.filterOtherFolderData(data);
        });
      } catch (e) {
        console.log(e);
      }
    },
    initializecontentview() {
      var self = this;
      var token = localStorage.getItem("token");
      $.ajax({
        type: "POST",
        url: "https://rtm.glueapi.io/report/viewed",
        contentType: "application/json; charset=utf-8",
        headers: {
          "X-AUTH-TOKEN": `${token}`,
        },
        data: JSON.stringify({
          idContent: self.currentid, // Content ID from content api response
          contentTitle: self.$route.path, // Content Longtitle from content api response
          site: "RTMKlik",
          dbLogging: 1,
        }),
        dataType: "json",
        success: function(data) {
          // console.log(data);
        },
        failure: function(errMsg) {
          console.log(errMsg);
        },
      });
    },
    initializepageview() {
      var self = this;
      $.ajax({
        type: "POST",
        url: "https://rtm.glueapi.io/report/page-view",
        contentType: "application/json",
        data: JSON.stringify({
          href: self.$route.path,
          title: "radio",
          site: "RTMKlik",
        }),
        dataType: "json",
        success: function(data) {
          // console.log(data);
        },
        failure: function(errMsg) {
          console.log(errMsg);
        },
      });
    },
    initializeContentForStart() {
      if (this.id) {
        setTimeout(
          function() {
            this.currentid = this.id;
          }.bind(this),
          400
        );
      } else {
        // this.getRadioData();
      }
      //get id from param
      //no param,thus initialize first item in radio list
    },
  },
};
</script>

<style scoped>
.pt-radio {
  margin-top: 16px;
  min-height: 80vh;
  padding-bottom: 40px;
}

@media screen and (max-width: 768px) {
  .pt-radio {
    margin-top: 68px;
  }
}
</style>
